// src/components/pages/Pessoa/tabs/PessoaTabColaborador.jsx

import { Box, Typography } from '@mui/material';

import Checkbox from '../../../form/Checkbox';
import InputNumber from '../../../form/InputNumber';

import { resolveColaboradorSections } from '../helpers/resolveColaboradorSections';
import { formatarNumero } from '../../../../utils/masks';

export default function PessoaTabColaborador({ module }) {
    const { dados } = module.state;
    const { change } = module.actions;

    const ramoAtividade = localStorage.getItem('ramoAtividade');
    const sections = resolveColaboradorSections({ ramoAtividade });

    return (
        <Box sx={{ display: 'grid', gap: 3 }}>
            <Typography variant="h6">Administrativo</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <Checkbox
                    text="Venda Interna"
                    name="pessoaColaborador.vendaInterna"
                    handleOnChange={change}
                    checked={!!dados.vendaInterna}
                    value={dados.vendaInterna}
                />
                <InputNumber
                    text="Comissão Interna"
                    type="text"
                    name="pessoaColaborador.comissaoInterna"
                    placeholder="Valor %"
                    inputWidth="120px"
                    handleOnChange={change}
                    value={dados?.comissaoInterna ? formatarNumero(dados.comissaoInterna) : ''}
                    readonly={!dados.vendaInterna}
                />
                <Checkbox
                    text="Venda Externa"
                    name="pessoaColaborador.vendaExterna"
                    handleOnChange={change}
                    checked={!!dados.vendaExterna}
                    value={dados.vendaExterna}
                />
                <InputNumber
                    text="Comissão Externa"
                    type="text"
                    name="pessoaColaborador.comissaoExterna"
                    placeholder="Valor %"
                    inputWidth="120px"
                    handleOnChange={change}
                    value={dados?.comissaoExterna ? formatarNumero(dados.comissaoExterna) : ''}
                    readonly={!dados.vendaExterna}
                />
            </Box>

            <Typography variant="h6">Dashboards / Custos</Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <Checkbox
                    text="Dashboard Financeiro"
                    name="pessoaColaborador.dashboardFinanceiro"
                    handleOnChange={change}
                    checked={!!dados.dashboardFinanceiro}
                    value={dados.dashboardFinanceiro}
                />
                <Checkbox
                    text="Dashboard Indústria"
                    name="pessoaColaborador.dashboardIndustria"
                    handleOnChange={change}
                    checked={!!dados.dashboardIndustria}
                    value={dados.dashboardIndustria}
                />
                <Checkbox
                    text="Custo Fixo"
                    name="pessoaColaborador.custoFixo"
                    handleOnChange={change}
                    checked={!!dados.custoFixo}
                    value={dados.custoFixo}
                />
                <Checkbox
                    text="Ativo"
                    name="pessoaColaborador.ativo"
                    handleOnChange={change}
                    checked={!!dados.ativo}
                    value={dados.ativo}
                />
            </Box>
        </Box>
    );
}
